import api from '../api';

/** An entry of a translated catalog, its name in the current language. */
export interface CatalogItem {
  id: number;
  name: string;
}

export const getScopes = () => api.get<CatalogItem[]>('/scopes/');

export const getTypes = () => api.get<CatalogItem[]>('/types/');

export const getTerms =() => api.get<CatalogItem[]>('/terms/');

/** Every Territorio, by name (the endpoint is paginated; there are only a handful). */
export const getTerritories = () => api.get<{ page: CatalogItem[] }>('/territories/', { limit: 100, sort: 'nombre' });
